export class Form {

    constructor() {
        this.post = new Map()
        this.files = new Array()
    }

    loadAnketa(a) {
        $.ajax({
            url: '/ajax.php?mid=1',
            type: 'POST',
            data: {
                action: 'load',
                id: a.id,
                name: a.name,
            },
            dataType: 'json',
            success: function callbackName(res){
                if (res['success'])
                {
                    a.childNodes[1].innerHTML = 'Скачать анкету!'
                    a.href = '/mod_files/' + a.name + '-download.docx'
                    a.removeAttribute('onclick')
                }
                else {
                    alert('Ajax Error ' + res['error'])
                }
            },
            error: function(err){
                alert('Ошибка! Попробуйте повотрить запрос позднее. Error: ' + err)
            }
        })
    }

    upload(a) {
        let input = document.createElement('input')
        input.type = 'file'
        input.name = 'file' + a.classList[1].substr(a.classList[1].indexOf('_'))
        input.multiple = true
        input.style.display = 'none'
        input.addEventListener('change', function() {
            let fileList = a.parentNode.children[1]
            let files = this.files
            for (let i = 0; i < files.length; i++) {
                let li = document.createElement('li');
                li.className = 'fileItem';
                li.innerHTML = `<span>${files[i].name}</span><a onclick="form.delete(this)" class="deleteButton"><svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="Black" stroke-linecap="round"/></svg></button>`
                fileList.appendChild(li)
            }
            // this.remove()
        })
        let form = document.querySelector('form.anketa-form')
        form.append(input)
        input.click()
    }

    delete(a) {
        let form = document.querySelector('form.anketa-form')
        let name = a.closest('.answer').children[0].classList[1]
        let input =  form.querySelector('input[type="file"][name="' + name + '"]')
        input.remove()
        a.parentNode.remove()
    }

    submitForm(event) {
        let form = event.target
        let check = new Array()
        for (let el in form) {
            if(form[el] != null) {
                if((form[el].nodeName == 'INPUT' && form[el].type == 'text' && form[el].value != '') || (form[el].nodeName == 'INPUT' && form[el].type == 'checkbox' && form[el].checked == true) || (form[el].nodeName == 'TEXTAREA' && form[el].value != '')) {
                    if(form[el].name)
                        this.post.set(form[el].name, form[el].value)
                }
                if(form[el].nodeName == 'INPUT' && form[el].type == 'file' && form[el].files.length > 0) {
                    for (let i = 0; i < form[el].files.length; i++) {
                        if (check.includes(form[el].files[i].name) === false) {
                            let fname = form[el].files[i].name.substr(0,form[el].files[i].name.indexOf('.'))
                            this.post.set(form[el].name + '_' + fname, form[el].value)
                            this.files.push(form[el].files[i])
                            check.push(form[el].files[i].name)
                        }
                    }
                }
            }
        }
        if(this.post !== undefined || this.post.length != 0) {
            let _this = this
            $.ajax({
                url: '/ajax.php?mid=2',
                type: 'POST',
                data: {
                    action: 'post',
                    json: JSON.stringify(Array.from(this.post)),
                },
                dataType: 'json',
                success: function callbackName(res){
                    if (res['success'])
                    {
                        if(_this.files !== undefined || _this.files.length != 0) {
                            for (let key in _this.files) {
                                if (_this.files.hasOwnProperty(key)) {
                                    let xhr = new XMLHttpRequest()
                                    xhr.responseType = 'json'
                                    xhr.open('POST', '/vsop/ajax/2/?action=file')
                                    let formData = new FormData()
                                    let file = _this.files[key]
                                    formData.append('file', file)
                                    xhr.setRequestHeader('Cache-Control', 'no-cache')
                                    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
                                    xhr.setRequestHeader("X-File-Name", encodeURIComponent(file.name))
                                    xhr.send(formData)
                                }
                            }
                        }
                    }
                    else {
                        alert('Ajax Error ' + res['error'])
                    }
                },
                error: function(err){
                    alert('Ошибка! Попробуйте повотрить запрос позднее. Error: ' + err)
                }
            })
        }
    }

}